export enum RecordCategory {
  MY = 'my',
  SHARED = 'shared',
}
